module.exports = __webpack_public_path__ + "static/media/joucho_fuantei_man.c2ad1cf0.png";